// "use client";

// import { Autocomplete, FormControl, FormHelperText, FormLabel, OutlinedInput } from "@mui/material";
// import type { AutocompleteProps } from "@mui/material";
// import React from "react";
// import { bbDropdownSelectSx, inputSx, paperSx } from "./BBAutoComplete.styles";
// import { bbDropdownLabelSx } from "../BBDropdown/BBDropdown.styles";

// export interface Option {
//   label: string;
//   value: string | number;
// }

// interface BBAutoCompleteProps {
//   name: string;
//   label?: string;
//   value?: string | number | null;
//   inputValue?: string;
//   options: Option[];
//   loading?: boolean;
//   isError?: boolean;
//   errorMessage?: string;
//   placeholder?: string;
//   disableClearable?: boolean;
//   freeSolo?: boolean;
//   required?: boolean;
//   disableFiltering?: boolean;
//   onChange: (name: string, value: string | number | null) => void;
//   onSearch?: (value: string) => void;
// }

// type ExtraAutocompleteProps = Omit<
//   AutocompleteProps<string | Option, false, boolean, boolean>,
//   "onChange" | "value" | "options" | "disableClearable"
// >;

// const BBAutoCompleteBase: React.FC<BBAutoCompleteProps & Partial<ExtraAutocompleteProps>> = ({
//   name,
//   label,
//   value = null,
//   inputValue,
//   options,
//   loading = false,
//   isError = false,
//   errorMessage,
//   placeholder = "",
//   disableClearable = false,
//   freeSolo,
//   onChange,
//   onSearch,
//   required,
//   disableFiltering = false,
//   ...restProps
// }) => {
//   const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

//   const selected: Option | null = value === null ? null : (options.find((o) => o.value === value) ?? null);
//   const handleChange = (_: React.SyntheticEvent, newValue: Option | string | null) => {
//     if (newValue === null) {
//       onChange(name, null);
//       return;
//     }

//     if (typeof newValue === "string") {
//       onChange(name, newValue);
//     } else {
//       onChange(name, newValue.value);
//     }
//   };

//   return (
//     <FormControl fullWidth size="small" error={isError}>
//       {label && (
//         <FormLabel sx={bbDropdownLabelSx} required={required}>
//           {label}
//         </FormLabel>
//       )}
//       <Autocomplete
//         freeSolo={freeSolo}
//         options={options}
//         value={selected}
//         inputValue={inputValue}
//         loading={loading}
//         getOptionLabel={(opt) => (typeof opt === "string" ? opt : opt.label)}
//         // Disable frontend filtering when backend search is used
//         filterOptions={disableFiltering ? (opts) => opts : undefined}
//         isOptionEqualToValue={(option, val) => {
//           if (!val) return false;
//           const optionValue = typeof option === "string" ? option : option.value;
//           const valValue = typeof val === "string" ? val : val.value;
//           return optionValue === valValue;
//         }}
//         disableClearable={disableClearable}
//         onChange={handleChange}
//         onInputChange={(_, newInputValue, reason) => {
//           if (reason === "input" || reason === "clear") {
//             onSearch?.(newInputValue);
//           }
//         }}
//         openOnFocus
//         renderInput={(params) => (
//           <OutlinedInput
//             {...params.InputProps}
//             inputProps={{
//               ...params.inputProps,
//               readOnly: isMobile,
//             }}
//             placeholder={placeholder}
//             fullWidth
//             sx={inputSx}
//           />
//         )}
//         sx={{
//           ...bbDropdownSelectSx,
//           ...(restProps.disabled && {
//             opacity: 0.6,
//             cursor: "not-allowed",
//             pointerEvents: "none",
//             "& .MuiOutlinedInput-root": { backgroundColor: "#f5f5f5" },
//             "& input": { cursor: "not-allowed" },
//           }),
//         }}
//         slotProps={{
//           paper: {
//             sx: {
//               ...paperSx,
//               "& .MuiAutocomplete-listbox": { maxHeight: "300px" },
//               "& .MuiAutocomplete-option": {
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//                 minWidth: "max-content",
//                 padding: "8px 16px",
//               },
//             },
//           },
//         }}
//         {...restProps}
//       />
//       {isError && <FormHelperText>{errorMessage}</FormHelperText>}
//     </FormControl>
//   );
// };

// export default BBAutoCompleteBase;
"use client";

import { Autocomplete, FormControl, FormHelperText, FormLabel, OutlinedInput } from "@mui/material";
import type { AutocompleteProps } from "@mui/material";
import React from "react";
import { bbDropdownSelectSx, inputSx, paperSx } from "./BBAutoComplete.styles";
import { bbDropdownLabelSx } from "../BBDropdown/BBDropdown.styles";

export interface Option {
  label: string;
  value: string | number;
}

interface BBAutoCompleteProps {
  name: string;
  label?: string;
  value?: string | number | null;
  inputValue?: string;
  options: Option[];
  loading?: boolean;
  isError?: boolean;
  errorMessage?: string;
  placeholder?: string;
  disableClearable?: boolean;
  freeSolo?: boolean;
  required?: boolean;
  disableFiltering?: boolean;
  onChange: (name: string, value: string | number | null) => void;
  onSearch?: (value: string) => void;
}

type ExtraAutocompleteProps = Omit<
  AutocompleteProps<string | Option, false, boolean, boolean>,
  "onChange" | "value" | "options" | "disableClearable"
>;

const BBAutoCompleteBase: React.FC<BBAutoCompleteProps & Partial<ExtraAutocompleteProps>> = ({
  name,
  label,
  value = null,
  inputValue,
  options,
  loading = false,
  isError = false,
  errorMessage,
  placeholder = "",
  disableClearable = false,
  freeSolo,
  onChange,
  onSearch,
  required,
  disableFiltering = false,
  ...restProps
}) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const selected: Option | null = value === null ? null : (options.find((o) => o.value === value) ?? null);

  const handleChange = (_: React.SyntheticEvent, newValue: Option | string | null) => {
    if (newValue === null) {
      onChange(name, null);
      return;
    }

    if (typeof newValue === "string") {
      onChange(name, newValue);
    } else {
      onChange(name, newValue.value);
    }
  };

  return (
    <FormControl fullWidth size="small" error={isError}>
      {label && (
        <FormLabel sx={bbDropdownLabelSx} required={required}>
          {label}
        </FormLabel>
      )}

      <Autocomplete
        freeSolo={freeSolo}
        options={options}
        value={selected}
        inputValue={inputValue}
        loading={loading}
        clearOnBlur={false}
        openOnFocus
        disableClearable={disableClearable}
        getOptionLabel={(opt) => (typeof opt === "string" ? opt : opt.label)}
        filterOptions={disableFiltering ? (opts) => opts : undefined}
        isOptionEqualToValue={(option, val) => {
          if (!val) return false;

          const optionValue = typeof option === "string" ? option : option.value;

          const valValue = typeof val === "string" ? val : val.value;

          return optionValue === valValue;
        }}
        onChange={handleChange}
        onInputChange={(_, newInputValue, reason) => {
          if (reason === "input") {
            onSearch?.(newInputValue);
          }
        }}
        renderInput={(params) => (
          <OutlinedInput
            {...params.InputProps}
            inputProps={{
              ...params.inputProps,
              readOnly: isMobile,
            }}
            placeholder={placeholder}
            fullWidth
            sx={inputSx}
          />
        )}
        sx={{
          ...bbDropdownSelectSx,
          ...(restProps.disabled && {
            opacity: 0.6,
            cursor: "not-allowed",
            pointerEvents: "none",
            "& .MuiOutlinedInput-root": {
              backgroundColor: "#f5f5f5",
            },
            "& input": {
              cursor: "not-allowed",
            },
          }),
        }}
        slotProps={{
          paper: {
            sx: {
              ...paperSx,
              "& .MuiAutocomplete-listbox": {
                maxHeight: "300px",
              },
              "& .MuiAutocomplete-option": {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                minWidth: "max-content",
                padding: "8px 16px",
              },
            },
          },
        }}
        {...restProps}
      />

      {isError && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};

export default BBAutoCompleteBase;
